import { FileItem } from '@/design-system';
import { useFileDownload } from '@/shared/hooks/use-file-download';
import { useOpenFileInNewTab } from '@/shared/hooks/use-open-file-in-new-tab';

export type VerificationFile = {
  id: string;
  fileId?: string;
  fileName?: string;
  fileSize?: number;
};

export const VerificationFileCard = ({
  file,
  url,
  onRemove,
}: {
  file: VerificationFile;
  /** Signed download URL resolved from `file.fileId` via the file service. */
  url?: string;
  onRemove?: (_id: string) => void;
}) => {
  const { openFileInNewTab } = useOpenFileInNewTab();
  const { downloadFile } = useFileDownload();

  return (
    <FileItem
      file={{
        id: file.id,
        name: file.fileName ?? '',
        contentType: 'application/pdf',
        size: file.fileSize,
        status: 'uploaded',
      }}
      onOpen={url ? () => void openFileInNewTab(url) : undefined}
      onDownload={url ? () => void downloadFile(url, file.fileName) : undefined}
      onRemove={onRemove ? () => onRemove(file.id) : undefined}
    />
  );
};
